import { useEffect, useState } from "react";
import { Link } from "react-router";

const KEY = "hv.cookie-hinweis";
const EVENT = "hv-cookie-hinweis";

/** Öffnet den Cookie-Hinweis erneut (Link in der Fußzeile). */
export function openCookieHinweis() {
  window.dispatchEvent(new Event(EVENT));
}

function seen(): boolean {
  try {
    return localStorage.getItem(KEY) !== null;
  } catch {
    return false;
  }
}

/**
 * Hinweis zu Cookies beim Besuch der Website. HandVero setzt nur technisch notwendige Cookies und Speicher ein (§ 25 Abs. 2 TDDDG),
 * dafür braucht es keine Einwilligung. Der Hinweis informiert trotzdem, ist erneut aufrufbar und hat keine vorangekreuzten Häkchen.
 * Kommen später Analyse- oder Komfortdienste dazu, werden sie hier als eigene Auswahl ergänzt und bleiben bis zur Zustimmung aus.
 */
export function CookieHinweis() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!seen()) setOpen(true);
    const show = () => setOpen(true);
    window.addEventListener(EVENT, show);
    return () => window.removeEventListener(EVENT, show);
  }, []);
  if (!open) return null;
  function close() {
    try {
      localStorage.setItem(KEY, new Date().toISOString());
    } catch {
      /* ohne Speicher erscheint der Hinweis beim nächsten Besuch erneut */
    }
    setOpen(false);
  }
  return (
    <section className="cookie-note" role="dialog" aria-label="Hinweis zu Cookies" aria-live="polite">
      <h2>Cookies und Datenschutz</h2>
      <p>
        HandVero verwendet nur technisch notwendige Cookies und Speicher, zum Beispiel damit Sie angemeldet bleiben. Wir setzen kein Tracking, keine Werbung und keine
        Dienste fremder Anbieter ein. Deshalb gibt es nichts abzulehnen. Dieser Hinweis erscheint nur, damit Sie Bescheid wissen.
      </p>
      <ul>
        <li>
          <b>Notwendig (immer aktiv):</b> Anmelden, Sicherheit, Ihre Einstellungen.
        </li>
        <li>
          <b>Analyse und Werbung:</b> nicht vorhanden.
        </li>
      </ul>
      <div className="cookie-actions">
        <button className="btn btn-primary btn-small" onClick={close}>
          Verstanden
        </button>
        <Link className="btn btn-ghost btn-small" to="/rechtliches#datenschutz" onClick={close}>
          Mehr in der Datenschutzerklärung
        </Link>
      </div>
    </section>
  );
}
